import {
  initCompareChartAccordion,
  initFAQAccordionModule,
} from '../modules/accordions';

import { DOMRouteHandler } from './DOMRouteHandler';
import { LocalizationForm } from '../modules/localization-form';
import { PostMessageClient } from '../modules/share-storage';
import { initBuyButton } from '../modules/buyNowButton';
import { initCartUpdater } from '../modules/cart/cartUpdate';
import { initVariantSelectChangeEventDispatcher } from '../utils/variantSelectChangeEvent';
import { removeAutoAppliedDiscountIfCookieDiscountIsPresent } from '../modules/discount-code';
import { setLocaleCallback } from '../modules/geo';
import { setCustomTextOrPromo } from '../modules/dynamicAnnouncementBar';
import { registerWebComponents } from '../web-components';
import { initBreederSelector } from '../modules/breeder-selector';
import { initShelterSelector } from '../modules/shelter-selector';
import { setupAddonCheckboxes } from '../addon-picker';
import { initConditionalElements } from '../modules/conditional-elements';
import { initB2BPDP } from '../modules/b2b-pdp';

export class Common extends DOMRouteHandler {
  static async initAsync(): Promise<void> {
    await initVariantSelectChangeEventDispatcher();
  }

  static init(): void {
    initBuyButton();

    const cartCount = document.querySelector('[data-cart-count]');

    if (!!cartCount) {
      initCartUpdater(cartCount as HTMLElement);
    }

    initFAQAccordionModule();
    initCompareChartAccordion();
    setCustomTextOrPromo();
    removeAutoAppliedDiscountIfCookieDiscountIsPresent();
    registerWebComponents();
    initBreederSelector();
    initShelterSelector();
    setupAddonCheckboxes();
    initConditionalElements();

    window.embark.cartStore = new PostMessageClient(
      'embarkvet-cart',
      'https://embarkvet.com/message/receiver/'
    );

    window.embark.cartStore.on('setLocale', setLocaleCallback);

    customElements.define('localization-form', LocalizationForm);

    initB2BPDP();
  }
}
